import type { useAccountSearchGet } from "@dealer-center/ddc-pages-account-search-fetch";
import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import { defaultFilters } from "@dealer-center/ddc-pages-account-search-interface";
import { createContext } from "react";

export const AccountSearchContext = createContext<useAccountSearchReturn>({
  page: 0,
  size: 10,
  updatePage: () => undefined,
  updateSize: () => undefined,
  updateSearchRequest: () => undefined,
  searchRequest: defaultFilters,
  isSearchDefault: true
});

interface useAccountSearchReturn {
  page: number;
  size: number;
  updatePage: (newPage: number) => void;
  updateSize: (newSize: number) => void;
  updateSearchRequest: (newSearchRequest?: dealerSearchIncoming) => void;
  searchRequest: dealerSearchIncoming;
  isSearchDefault: boolean;
  accountSearchGet?: ReturnType<typeof useAccountSearchGet>;
}
